module.exports = __webpack_public_path__ + "f83eea997a3c4a95a5b55c59584ee707.MP3";